import { lazy, Suspense } from 'react';

import { ClassicExperience } from '@/console/app/classic-experience';
import { resolveExperience } from '@/console/host/resolve-experience';
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag/use-feature-flag';
import { FEATURE_MODERN_UI } from '@/shared/hooks/use-feature-flag/use-feature-flag.constants';

const ComingSoon = lazy(() =>
  import('@modern/app/coming-soon/coming-soon').then((module) => ({
    default: module.ComingSoon,
  })),
);

export const ExperienceGate = () => {
  const optedIntoModern =
    resolveExperience(window.location.pathname) === 'modern';

  const { isFeatureFlagEnabled, isLoading } = useFeatureFlag({
    skip: !optedIntoModern,
  });

  if (!optedIntoModern) {
    return <ClassicExperience />;
  }

  if (isLoading) {
    return null;
  }

  if (!isFeatureFlagEnabled(FEATURE_MODERN_UI)) {
    return <ClassicExperience />;
  }

  return (
    <Suspense fallback={null}>
      <ComingSoon />
    </Suspense>
  );
};
